import React from 'react';
export const HiddenDescription = ({ id, children }) => {
    const hiddenStyle = {
        border: 0,
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        width: '1px',
        whiteSpace: 'nowrap'
    };
    return (React.createElement("span", { id: id, style: hiddenStyle }, children));
};
